import { render, staticRenderFns } from "./top-routes.vue?vue&type=template&id=6b224d7c&scoped=true&"
import script from "./top-routes.vue?vue&type=script&lang=js&"
export * from "./top-routes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b224d7c",
  null
  
)

export default component.exports